import styled from 'styled-components';

export const TabsStyles = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
`;
